import { w } from '@/lib/api'
import type { CaseSearchItem } from '@/lib/queries/business/types'

export const editCaseMutation = {
  mutationFn: (data: {
    caseId: number
    categoryId: number
    tags: string[]
    assignee?: number[]
    isPublic?: boolean
  }): Promise<CaseSearchItem> =>
    w
      .post(
        {
          assignee: data.assignee,
          is_public: data.isPublic,
          path_id: data.categoryId,
          tags: data.tags,
        },
        `/business/v1/case/${data.caseId}`
      )
      .json(),
}
